// extracted by mini-css-extract-plugin
export default {"newsList":"index-module_newsList_WVI5i","news":"index-module_news_2Z4L7","time":"index-module_time_r-V53","title":"index-module_title_wi5Jn"};